import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
import store from './store';
import 'ant-design-vue/dist/reset.css';

const app = createApp(App);
// createApp(App).use("#app")
app.use(store);
app.use(Antd).mount('#app');
